<template>
  <section class="agenda monday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Wednesday, September 18th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                VIP Lunch by Chintai
              </p>
              <div class="cards__description">
                <p>12:00 PM - 2:00 PM</p>
              </div>
            </div>
            <br class="linebrk">
            <div v-for="(speaker, index) in speakers" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>5:30 PM - 7:30 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Dinner
              </p>
              <div class="cards__description">
                <p>7:30 PM - 9:30 PM</p>
              </div>
            </div>
            <div class="cards__single party">
              <p class="cards__title">
                VIP After Party
              </p>
              <div class="cards__description">
                <p>9:30 PM - 1:00 AM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      speakers: [
      /*{
        imgClass: 'nick',
        name: 'Nick Mancini',
        title: 'Co-Founder & Chief Product Officer - Parlay Labs',
        time: '3:00 PM - 3:30 PM',
      },*/
      {
        imgClass: 'jay',
        name: 'Jack Jay',
        title: 'Founder - Persist Ventures',
        time: '12:00 PM - 12:30 PM',
      },
      {
        name: 'Panel 1: Decentralized AI Across Multi-Chain Ecosystems',
        title: 'Moderator: Christian Pusateri, Co-Founder at Super Alignment<br> Himanshu Tyagi, Co-Founder at Sentient <br> Rahul Nandwani, Co-Founder & CEO at Vglnt<br>Kyle Song, APAC Web3 Specialist at Google Cloud<br>Nick Emmons, Co-Founder at Allora<br> Sean Ren, CEO at Sahara AI',
        time: '12:30 PM - 1:00 PM',
        class: 'noheight'
      },
      {
        name: 'DNA Deal Desk / Chintai',
        title: '',
        time: '1:00 PM - 2:00 PM',
        class: 'noheight'
      },
      {
        imgClass: 'sandeep',
        name: 'Sandeep Nailwal',
        title: 'Co-Founder - Polygon',
        time: '2:00 PM - 2:30 PM',
      },
      {
        imgClass: 'peter',
        name: 'Peter Espino',
        title: 'Co-Founder - Mind Network',
        time: '2:30 PM - 3:00 PM',
      },
      {
        imgClass: 'c-b',
        name: 'Brock Pierce & Charles Hoskinson',
        title: 'Co-Founder - DNA / CEO & Founder - Input Output',
        time: '3:00 PM - 3:30 PM',
      },
      {
        name: 'Panel 2: The Investor’s Guide to Web3: Spotting the Next Big Thing',
        title: 'Jae Brukhman, Co-Founder at CoinFund <br>Kelli, Partner & Chief Growth Officer at Arrington Capital <br>Calvin Poon, Investor at Spartan<br>Alpen Sheth, Partner at Borderless Capital<br>Masha Prusso, Marketing at Aethir',
        time: '3:30 PM - 4:00 PM',
        class: 'noheight'
      },
      {
        imgClass: 'jun',
        name: 'Jun',
        title: 'CTO - GAIB',
        time: '4:00 PM - 4:15 PM',
      },
      {
        imgClass: 'sakib',
        name: 'Shadman Sakib',
        title: 'Founder & CEO - Vurse',
        time: '4:15 PM - 4:45 PM',
      },
      {
        imgClass: 'nikolay',
        name: 'Nikolay Filichkin',
        title: 'Co-Founder & CBO - Compute Labs',
        time: '4:45 PM - 5:00 PM',
      },
      {
        imgClass: 'yago',
        name: 'Edan Yago',
        title: 'CEO, Co-Founder - BitcoinOS',
        time: '5:00 PM - 5:30 PM',
      },
      {
        imgClass: 'ssb',
        name: 'Scott Walker, Brock Pierce & Scott Keto',
        title: 'DNA & CoinList',
        time: '5:30 PM - 6:00 PM',
      },
      {
        imgClass: 'latona',
        name: 'Rick Latona',
        title: 'CEO, Founder - WOW!? / Giant Panda',
        time: '6:00 PM - 6:30 PM',
      },
      {
        imgClass: 'olsson',
        name: 'David Olsson',
        title: 'Global Head of Institutional Sales - Kraken',
        time: '6:30 PM - 7:00 PM',
      },
      {
        imgClass: 'stefan',
        name: 'Stefan',
        title: 'CEO - Nesa',
        time: '7:00 PM - 7:30 PM',
      }]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
    shouldHideCircle(speaker) {
      return speaker.class && speaker.class.includes('no-circle');
    }
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
